package com.dotdrives.model

import kotlinx.serialization.Serializable
import kotlinx.serialization.SerialName

/** Publication and provider activation are separate: preserved connections need no reconnection. */
@Serializable
enum class FormPaymentReadiness {
    @SerialName("ready") READY,
    @SerialName("migration_pending") MIGRATION_PENDING,
    @SerialName("restricted") RESTRICTED,
    @SerialName("disconnected") DISCONNECTED;

    val connectionPreserved: Boolean get() = this != DISCONNECTED
    val canPublish: Boolean get() = this == READY || this == MIGRATION_PENDING
    val summary: String get() = when (this) {
        READY -> "Stripe connected · Online giving enabled"
        MIGRATION_PENDING -> "Stripe connection preserved · Payment migration pending"
        RESTRICTED -> "Stripe connected · Payments not ready"
        DISCONNECTED -> "Connect Stripe to accept gifts"
    }
    val message: String get() = when (this) {
        READY -> "Stripe connected · Online giving enabled"
        MIGRATION_PENDING -> "Your Stripe connection is preserved. Forms can be enabled; new payments in this app await migration completion. Existing Stripe giving continues. No reconnection is needed."
        RESTRICTED -> "Stripe is connected, but payments are not ready. Review the existing account in integration settings."
        DISCONNECTED -> "Connect Stripe before publishing this form."
    }
}
